// Social Contribution Initiatives page Indonesian translations

export default {
  pageTitle: "Inisiatif Kontribusi Sosial",
  breadcrumbHome: "Beranda",
  breadcrumbSustainability: "Keberlanjutan",
  breadcrumbCurrent: "Inisiatif Kontribusi Sosial",
  title: "Inisiatif Kontribusi Sosial",
  sustainability: "Keberlanjutan",
  conceptOfSustainability: "Konsep Keberlanjutan",
  environmentalInitiatives: "Inisiatif Lingkungan",
  occupationalHealthSafety: "Kesehatan & Keselamatan Kerja",
  
  // Social Contribution Details Section
  socialContributionTitle: "Kontribusi Sosial di P.T.  Eagle Industry Indonesia",
  socialContributionDesc: "Di P.T.  Eagle Industry Indonesia, kami berkomitmen untuk memberikan dampak positif pada masyarakat melalui inisiatif Tanggung Jawab Sosial Perusahaan (CSR) kami. Program kontribusi sosial kami berfokus pada mendukung masyarakat, membantu mereka yang membutuhkan, dan memupuk pembangunan berkelanjutan di area sekitar operasi kami.",
  
  // CSR Activities Section
  csrActivitiesTitle: "Aktivitas CSR",
  csrActivitiesSubtitle: "Komitmen kami terhadap tanggung jawab sosial dan dukungan masyarakat",
  
  // Qurban Activity
  qurbanTitle: "Aktivitas Qurban - Eid al-Adha",
  qurbanDesc: "Perusahaan menjalankan program Qurban tahunan pada Eid al-Adha. Distribusi daging Qurban diberikan kepada anak yatim/miskin/membutuhkan di sekitar perusahaan.",
  qurbanHighlight1: "Program Qurban tahunan diadakan setiap Eid al-Adha",
  qurbanHighlight2: "Distribusi daging Qurban kepada komunitas yang kurang mampu",
  qurbanHighlight3: "Fokus pada anak yatim, miskin, dan membutuhkan di sekitar lokasi perusahaan",
  qurbanHighlight4: "Melibatkan karyawan dalam implementasi program",
  qurbanCaption: "Aktivitas Qurban Eid al-Adha",
  
  // Ramadhan Charity Activity
  ramadhanTitle: "Amal Ramadhan untuk Anak Yatim & Yang Membutuhkan",
  ramadhanDesc: "Perusahaan secara teratur mengadakan aktivitas amal Ramadhan dengan mengundang anak yatim untuk berbagi kebahagiaan di bulan suci.",
  ramadhanHighlight1: "Program amal teratur setiap Ramadhan",
  ramadhanHighlight2: "Mengundang anak yatim untuk berbuka puasa bersama",
  ramadhanHighlight3: "Memberikan bantuan dalam bentuk amal dan perlengkapan sekolah",
  ramadhanHighlight4: "Menciptakan momen berbagi kebahagiaan di bulan suci Ramadhan",
  ramadhanCaption: "Amal Ramadhan untuk Anak Yatim & Yang Membutuhkan",
  
  // Flood Victim Support Activity
  floodVictimTitle: "Dukungan Perusahaan untuk Korban Banjir",
  floodVictimDesc: "Perusahaan memberikan bantuan kepada masyarakat sekitar yang terkena dampak banjir sebagai bentuk kepedulian terhadap lingkungan sekitar.",
  floodVictimHighlight1: "Respons cepat terhadap bencana banjir di sekitar perusahaan",
  floodVictimHighlight2: "Distribusi bantuan dalam bentuk kebutuhan pokok dan pasokan makanan",
  floodVictimHighlight3: "Bantuan langsung kepada korban banjir yang terkena dampak",
  floodVictimHighlight4: "Bentuk kepedulian sosial terhadap masyarakat sekitar",
  floodVictimCaption: "Bantuan Korban Banjir",
  
  // Related Topics Section
  relatedTopicsTitle: "Topik Keberlanjutan Terkait",
  relatedTopicsSubtitle: "Jelajahi lebih lanjut tentang inisiatif keberlanjutan kami",
  conceptOfSustainabilityCard: "Konsep Keberlanjutan",
  environmentalInitiativesCard: "Inisiatif Lingkungan",
  occupationalHealthSafetyCard: "Kesehatan & Keselamatan Kerja"
};